import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const initialState = {
    homeData: null,
    userGuidData: null,
    welcomeScreenData: null
}

export const fetchWelcomeScreen = createAsyncThunk('home/fetchWelcomeScreen', async () => {
    try {
        const response = await axios.get(`https://${process.env.REACT_APP_domain}/api/ga/en/0/welcome_screen`);
        return response.data.data;
    } catch (error) {
        console.error('Error fetching welcome screen:', error);
        throw error;
    }
});

const homeReducer = createSlice({
    name: "home",
    initialState,
    reducers: {
        setHomeData: (state, actions) => {
            state.homeData = actions.payload
        },
        setUserGuidData: (state, actions) => {
            state.userGuidData = actions;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchWelcomeScreen.fulfilled, (state, action) => {
            state.welcomeScreenData = action.payload;
            console.log("welcomeScreenData>>>",state.welcomeScreenData)
        }).addCase(fetchWelcomeScreen.rejected, (state, action) => {
            state.welcomeScreenData = null;
        }).addCase(fetchWelcomeScreen.pending, (state, action) => {
            state.welcomeScreenData = null;
        })
    }
});


export const { setHomeData, setUserGuidData } = homeReducer.actions;

export const homeState = (state => state.home);


export default homeReducer.reducer;